import React, { useEffect, useState } from "react";
import "moment/locale/pt-br.js";
import Filter from "./filter";
import Table from "./table";
import ReportAcordeon from "../../../Components/ReportAcordeon";
import {
  getConsolidatedKnowledgeEvaluation,
  getDownloadReport,
  getMenuData,
  postDownloadReport,
} from "../../../../../services/NexiDigitalAPI";

const ConsolidatedKnowledgeEvaluation = ({ index, expanded: _expanded }) => {
  const idReport = 12;
  const idCompany = getMenuData().idCompany;
  const name = "Relatório Consolidado de Avaliação de Conhecimento";
  const description =
    "Este relatório traz um consolidado das avaliações de conhecimento com dados agrupados por avaliação, treinamento e turma.";
  const [expanded, setExpanded] = useState(_expanded);
  const [loading, setLoading] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [requestFilters, setRequestFilters] = useState({});

  const onClickExpanded = (value) => {
    setExpanded(value);
  };

  const actionFilter = async (values) => {
    if (expanded) {
      setLoading(true);

      const filter = { ...requestFilters, ...values };
      setRequestFilters(filter);

      getConsolidatedKnowledgeEvaluation(filter)
        .then((response) => {
          const responseData = response.data;

          setTotalRecords(responseData.totalRecords);
          setData(responseData.result);
        })
        .finally(() => setLoading(false));
    }
  };

  const downloadEvent = async () => {
    if (loading) {
      return;
    }

    setLoadingDownload(true);
    const { idEvaluation, idTeam, nodeCode } = requestFilters;
    await postDownloadReport(idReport, { idEvaluation, idCompany, idTeam, nodeCode });
    await requestDownloadReport();
  };
  const requestDownloadReport = async (startTime = Date.now()) => {
    try {
      const response = await getDownloadReport(idReport);
      const { status, fileUrl } = response?.data || {};

      if (status === "Waiting") {
        if (Date.now() - startTime >= 30000) {
          setLoadingDownload(false);
          throw new Error("Tempo limite de 30 segundos atingido ao aguardar o relatório.");
        }
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return requestDownloadReport(startTime);
      }

      if (status === "Done" && fileUrl) {
        getFileReport(fileUrl);
        setLoadingDownload(false);
      }
    } catch (error) {
      setLoadingDownload(false);
    }
  };

  const getFileReport = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.click();
  };

  const filter = (
    <Filter
      actionFilter={actionFilter}
      loading={loading || loadingDownload}
      expanded={expanded}
      downloadEvent={downloadEvent}
    />
  );

  const result = (
    <Table
      data={data}
      loading={loading}
      actionFilter={actionFilter}
      totalRecords={totalRecords}
    />
  );

  useEffect(() => {
    if (!expanded) {
      setData([]);
      setTotalRecords(0);
      setRequestFilters({});
    }
  }, [expanded]);

  return (
    <ReportAcordeon
      onClickExpanded={onClickExpanded}
      name={name}
      description={description}
      filter={filter}
      result={result}
      index={index}
      expanded={expanded}
    />
  );
};

export default ConsolidatedKnowledgeEvaluation;
